import { getRoute } from '@utils/route';

export const HEALTH_QUOTE_PAYMENT_PAGE_URL = '/health-insurance-quote-payment/:orderNumber/:billingId';

type RouteParams = {
  orderNumber: string;
  billingId: number;
};

export const routeHealthQuotePaymentPage = (routeParams: RouteParams) => getRoute(HEALTH_QUOTE_PAYMENT_PAGE_URL, { routeParams });
